<template>
  <Modal2 :modalId="modalId" ref="modal2">
    <div class="mdl-body-s">
      <h2>
        <img
          src="@/assets/icons/ico_info.png"
          alt="情報アイコン"
          class="ico-bace ico-s"
        />契約の自動更新をオフにしてもよろしいですか？
      </h2>
      <p>
        {{ ascmuSubscription?.expiseAtText() }}までご利用いただけます。
      </p>
    </div>

    <div class="modal-footer btn-area" >
      <Button class="btn btn-cancel" data-bs-dismiss="modal">
        キャンセル
      </Button>
      <Button @click="confirmAction">更新する</Button>
    </div>

  </Modal2>
</template>

<script>
import { Button, Modal2 } from "components";

export default {
  name: "AutoRenewalOffConfirmModal",
  props: {
    modalId: {
      type: String,
      default: "",
    },
  },
  components: {
    Button,
    Modal2,
  },
  data() {
    return {
      icons: {
      },
      ascmuSubscription: null,
    };
  },
  methods: {
    async openModal(ascmuSubscription) {
      this.ascmuSubscription = ascmuSubscription;
      this.$refs.modal2.openModal();
    },
    async confirmAction() {
      this.$emit("confirm");
      this.$refs.modal2.closeModal();
    },
  },
};
</script>
